import React, { Component } from 'react';
import './Presentation.css';
import foto2 from '../../assets/perfil-recortado.png';
import { TbFolders } from 'react-icons/tb';
import { BsChatDots } from 'react-icons/bs';
import { SlRocket } from 'react-icons/sl';
import { HiOutlineDownload} from 'react-icons/hi';
import curriculum from '../../assets/Curriculum Vitae Pedro Santana.pdf';
import Socials from '../Socials/Socials';

class Presentation extends Component {
  render() {
    return (
      <section id="presentation">
        <div className="intro">
        <h5>Olá, eu sou o</h5>
        <h1>Pedro Santana</h1>
        <h4>Desenvolvedor Fullstack Júnior</h4>

        <a href={ curriculum } download className="download-btn">
          <HiOutlineDownload />
          <span>Currículo</span>
        </a>
        </div>

        <Socials />

        <div className="photo-cards-container">
          <div className="background">
            <div className="bg-photo">
              <img src={ foto2 } alt="" className="photo" />
            </div>
          </div>

          <div className="cards-container">
        <div className="card">
          <TbFolders className="icon"/>
          <div className="card-text">
            <span className="card-title">Projetos</span>
            <span>20+ projetos desenvolvidos</span>
          </div>
        </div>

        <div className="card">
          <BsChatDots className="icon"/>
          <div className="card-text">
            <span className="card-title">Idiomas</span>
            <span>Português fluente</span>
            <span>Inglês avançado</span>
          </div>
        </div>

        <div className="card">
          <SlRocket className="icon"/>
          <div className="card-text">
            <span className="card-title">Trabalho</span>
            <span>Aberto a freelances e fixo</span>
          </div>
        </div>
      </div>
        </div>
      </section>
    )
  }
}

export default Presentation;